// changeUserStatusModal.js
// A modal to change the user status of an employee by an admin level user

import { useState } from "react";
import Select from "react-select";
import styles from "./changeUserStatusModal.module.css";

export const ChangeUserStatusModal = ({ onClose, onSubmit }) => {
  const [userStatus, setUserStatus] = useState(null);
  const [days, setDays] = useState(null);

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2 className={styles.modalHeader}>Change User Status</h2>
        <div className={styles.modalBody}>
          <p>Choose the new user status for the employee</p>
          <Select
            value={userStatus}
            onChange={(selectedOption) => setUserStatus(selectedOption)}
            options={[
              { value: "A", label: "Active" },
              { value: "I", label: "Inactive" },
              { value: "T", label: "Terminated" },
            ]}
            isClearable={true}
            isSearchable={true}
            placeholder="Select User Status"
          />
          <p>Enter the number of days to keep the employee active</p>
          <input
            type="number"
            placeholder="Days"
            value={days}
            onChange={(e) => setDays(e.target.value)}
          />
          <div className={styles.modalButtons}>
            <button
              onClick={() => onSubmit(userStatus.value, days)}
              disabled={!userStatus?.value || !days}
              className={styles.changeUserStatusButton}
            >
              Change User Status
            </button>
            <button onClick={onClose} className={styles.cancelButton}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
